import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Presence } from '@snapshots/session';
import '@beyond-js/ui/tokens.css';
import '@beyond-js/ui/styles.css';
import '@beyond-js/ui/fonts.css';
import { device } from '@snapshots/theme';
import { App } from './app';

// The first paint is already in the language and appearance this device last had
device.restore();

const root = document.getElementById('root');
if (!root) throw new Error('The page has no #root element');

createRoot(root).render(
	<StrictMode>
		<BrowserRouter>
			<Presence>
				<App />
			</Presence>
		</BrowserRouter>
	</StrictMode>
);
